module.exports = __webpack_public_path__ + "static/img/3.a9d2350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Infidelidad-Riesgos-Financieros/3.png
// module id = Va61
// module chunks = 0